
import { createContext, useContext, useState, ReactNode } from 'react';

const ProductModalContext = createContext(undefined);

export function ProductModalProvider({ children }) {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openProductModal = (product) => {
    setSelectedProduct(product);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeProductModal = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setSelectedProduct(null);
      document.body.style.overflow = '';
    }, 300);
  };

  return (
    <ProductModalContext.Provider
      value={{
        selectedProduct,
        isModalOpen,
        openProductModal,
        closeProductModal
      }}
    >
      {children}
    </ProductModalContext.Provider>
  );
}

export function useProductModal() {
  const context = useContext(ProductModalContext);
  if (!context) {
    throw new Error('useProductModal must be used within a ProductModalProvider');
  }
  return context;
}
